import { render } from "./ReviewRequestModal.vue?vue&type=template&id=49582c6d&scoped=true&ts=true"
import script from "./ReviewRequestModal.vue?vue&type=script&lang=ts"
export * from "./ReviewRequestModal.vue?vue&type=script&lang=ts"

import "./ReviewRequestModal.vue?vue&type=style&index=0&id=49582c6d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49582c6d"]])

export default __exports__